import { AccountDtoResponse } from '../dto/account.res.dto';
import Account from '../../application/domain/entities/account';

export default class AccountMapper {
  static mapAccountDtoToAccount(accountDto: AccountDtoResponse | null): Account | null {
    if (!accountDto) {
      return null;
    }
    return new Account(
      accountDto.id,
      accountDto.accountName,
      accountDto.address1,
      accountDto.address2,
      accountDto.city,
      accountDto.state,
      accountDto.zipCode,
      accountDto.phoneNumber,
      accountDto.website,
      accountDto.logo,
      accountDto.i9ServiceStatus,
      accountDto.i9GoLiveDate,
      accountDto.i9DeactivationDate,
      accountDto.vtAccountStatus,
      accountDto.accountManagerEmail,
      accountDto.accountManagerFirstName,
      accountDto.accountManagerLastName,
      accountDto.accountManagerPhone,
      accountDto.salesForceAccountId || '',
      accountDto.reportsEnabled === true
    );
  }
}
